import { LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { ButtonEnums } from '../button';
import { ActionListGroupItemPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';
import { SpanPlaceholderSizes } from './placeholders.enums';

@customElement(PlaceholderTags.ListGroupItem)
export class AtlActionListGroupItemPlaceholder
   extends LitElement
   implements ActionListGroupItemPlaceholderProps
{
   declare showTitle?: boolean;
   declare showStatus?: boolean;
   declare showIcon?: boolean;
   declare showTruncateText?: boolean;
   declare showActionButton?: boolean;

   constructor() {
      super();
      this.showTitle = true;
   }

   static properties = {
      showTitle: { attribute: 'show-title', type: Boolean },
      showStatus: { attribute: 'show-status', type: Boolean },
      showIcon: { attribute: 'show-icon', type: Boolean },
      showTruncateText: { attribute: 'show-truncate-text', type: Boolean },
      showActionButton: { attribute: 'show-action-button', type: Boolean },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
            width: 100%;
         }
      `,
   ];

   render() {
      return html`
         <div class="list-group-item">
            ${this.showIcon
               ? html`<div class="action-icon">
                    <atlantis-span-placeholder
                       taller
                       size=${SpanPlaceholderSizes.ExtraSmall}
                    ></atlantis-span-placeholder>
                 </div>`
               : nothing}
            <div class="action-body">
               ${this.showTitle
                  ? html`<div class="action-title">
                       <atlantis-span-placeholder
                          size=${SpanPlaceholderSizes.Small}
                       ></atlantis-span-placeholder>
                    </div>`
                  : nothing}
               ${this.showStatus
                  ? html`<div class="action-status">
                       <atlantis-span-placeholder
                          size=${SpanPlaceholderSizes.Smaller}
                       ></atlantis-span-placeholder>
                    </div>`
                  : nothing}
               <div class="action-text">
                  ${this.showTruncateText
                     ? html`<atlantis-span-placeholder
                          size=${SpanPlaceholderSizes.Large}
                       ></atlantis-span-placeholder>`
                     : html`
                          <atlantis-span-placeholder
                             size=${SpanPlaceholderSizes.Medium}
                          ></atlantis-span-placeholder>
                          <atlantis-span-placeholder
                             size=${SpanPlaceholderSizes.ExtraLarge}
                          ></atlantis-span-placeholder>
                          <atlantis-span-placeholder
                             size=${SpanPlaceholderSizes.Smaller}
                          ></atlantis-span-placeholder>
                          <atlantis-span-placeholder
                             size=${SpanPlaceholderSizes.Medium}
                          ></atlantis-span-placeholder>
                          <atlantis-span-placeholder
                             size=${SpanPlaceholderSizes.Smaller}
                          ></atlantis-span-placeholder>
                       `}
               </div>
            </div>
            ${this.showActionButton
               ? html`<div class="action-cta">
                    <atlantis-button
                       variant=${ButtonEnums.ButtonVariant.Action}
                       fullWidth
                       title="Action Button Loading"
                       class="w-100"
                    >
                       <atlantis-span-placeholder
                          size=${SpanPlaceholderSizes.Smaller}
                       ></atlantis-span-placeholder>
                    </atlantis-button>
                 </div>`
               : nothing}
         </div>
      `;
   }
}
